module.exports = __webpack_public_path__ + "static/media/logo-abrasel.d72c61f3.png";